package com.neurobs.react.semanticui

import com.neurobs.react.ReactUtil
import org.scalajs.dom
import slinky.core.{SyntheticEvent, TagElement}
import slinky.core.facade.ReactRef
import slinky.web.html._

object UiInputFactory {

  def FileInput(inputPlaceholder: String, inputRef: ReactRef[dom.html.Input], inputAccept: String = "*")(implicit uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("input"),
      style := uiElementModifiers.createStyle
    )(
      input(
        `type` := "file",
        placeholder := inputPlaceholder,
        ref := inputRef,
        accept := inputAccept
      )
    )
  }

  def TextInput(inputPlaceholder: String, inputRef: ReactRef[dom.html.Input])(implicit uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("input"),
      style := uiElementModifiers.createStyle
    )(
      input(
        `type` := "text",
        placeholder := inputPlaceholder,
        ref := inputRef,
      )
    )
  }

}
